export default {
  title: "DiResto",
};
